import { IPopover } from '../components/PopOver'
import _ from 'lodash'

export function isPopoverArray(value?: any[] | string | IPopover): value is IPopover[] {
  return _.isArray(value) && (value as IPopover[])?.every((m) => m.body)
}

export function isPopover(value?: any[] | string | IPopover): value is IPopover {
  return !_.isUndefined(value) && (value as IPopover).body != undefined
}

export function isStringArray(value?: any[] | string | IPopover): value is string[] {
  return _.isArray(value) && (value as string[])?.every((m) => isString(m))
}

export function isString(value?: any[] | string | IPopover): value is string {
  return !_.isUndefined(value) && typeof value === 'string'
}
